import KunLoading110 from './src/index'

KunLoading110.install = function (Vue) {
	Vue.component(KunLoading110.name, KunLoading110);
}

export default KunLoading110;
